import { useSearchParams } from "react-router";

import {
  TRACK_VIEW_PARAM,
  TrackViewType,
} from "@vega-modules/scenes/CoInvestmentsGP/constants/trackPageConstants";

const validViewStrings: readonly string[] = Object.values(TrackViewType);

const isTrackViewType = (value: string): value is TrackViewType =>
  validViewStrings.includes(value);

const parseTrackView = (value: string | null): TrackViewType | null =>
  value !== null && isTrackViewType(value) ? value : null;

export const useTrackView = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const activeView =
    parseTrackView(searchParams.get(TRACK_VIEW_PARAM)) ?? TrackViewType.Process;

  const setActiveView = (view: TrackViewType) => {
    setSearchParams({ [TRACK_VIEW_PARAM]: view });
  };

  return { activeView, setActiveView };
};
